import { Auth } from "aws-amplify";
import { setClientData } from "../../services/UserService";
import { fleetSchdData } from "./scheduleConstants";

export const AUTH_ROUTES = [
  "signin",
  "signup",
  "confirmemail",
  "confirmmobile",
  "resetpassword",
];

export const TENANT_TYPE = {
  Corporate: "Corporate",
  Retail: "Retail",
  Chorus: "Chorus",
};

export const USER_ROLES = {
  viewOnlyUserCorp: "viewOnlyUserCorp",
  userCorp: "userCorp",
  adminCorp: "adminCorp",
  superAdminCorp: "superAdminCorp",

  viewOnlyUserRetail: "viewOnlyUserRetail",
  userRetail: "userRetail",
  adminRetail: "adminRetail",
  chorusUser: "chorusUser",
};

export const USER_ROLES_STR = {
  viewOnlyUserCorp: "View Only User",
  userCorp: "User",
  adminCorp: "Admin",
  superAdminCorp: "Super Admin",
};

export const sideMenuAccessForUser = {
  superAdminCorp: [
    "dashboard",
    "deviceView",
    "reports",
    "location",
    "schedules",
    "sites",
    "users",
    "ota",
    "settings",
    "help",
    "serviceTool"
  ],
  adminCorp: [
    "dashboard",
    "deviceView",
    "reports",
    "location",
    "schedules",
    "users",
    "ota",
    "help",
    "serviceTool"
  ],
  userCorp: ["dashboard", "deviceView", "reports", "help"],
  viewOnlyUserCorp: ["dashboard", "deviceView", "reports", "help"],
};

export const removeAllLocalValuesOfUser = () => {
  localStorage.removeItem("firstAppRenderCompleted");
  localStorage.removeItem("currentSite");
  localStorage.removeItem("filters");
  localStorage.removeItem("selectedTheme");
  sessionStorage.removeItem("pagination");
  sessionStorage.removeItem("searchKey");
  sessionStorage.removeItem("userDashboardDetails");
  sessionStorage.removeItem("refreshRateDashboard");
  sessionStorage.removeItem("refreshRateDeviceView");
  sessionStorage.removeItem("activeFilter");
  sessionStorage.removeItem("isShowUnread");
  sessionStorage.removeItem("isShowEvent");
};

export const removeAllLocalValuesOnLogout = () => {
  localStorage.removeItem(fleetSchdData);
  localStorage.removeItem("originalPreferredWifiList");
};

export const updateWebInfo = async (userName) => {
  try {
    const currentSite = localStorage.getItem("currentSite");
    let customFilters = localStorage.getItem("filters");
    let selectedTheme = localStorage.getItem("selectedTheme");

    let storedDashboardRate = localStorage.getItem("refreshRateDashboard") ;
    let storedDeviceViewRate = localStorage.getItem("refreshRateDeviceView");

    if (customFilters) {
      customFilters = JSON.parse(customFilters);
    }
    const queryParam = {
      deviceId: "webInfo",
      userId: userName,
      value: {
        selectedSiteId: currentSite,
        customFilters: customFilters || [],
        selectedTheme: selectedTheme || "",
        refreshRateDeviceView: storedDeviceViewRate,
        refreshRateDashboard: storedDashboardRate,
      },
    };
    await setClientData(queryParam);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateCommonInfo = async (userName, deviceIdArray, value) => {
  try {
    const queryParam = {
      userId: userName,
      deviceId: deviceIdArray,
      value: value,
    };
    await setClientData(queryParam);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const logoutUserFromCurrentDevice = async (
  userName = "",
  currentDeviceKey = ""
) => {
  try {
    removeAllLocalValuesOfUser();
    removeAllLocalValuesOnLogout();
    await updateCommonInfo(userName, [currentDeviceKey], {
      forceLogout: false,
      deviceLogin: false,
      lastLoginTime: null
    });
    await Auth.signOut();
    sessionStorage.removeItem("keepmelogin");
    localStorage.removeItem("selectedSortKey");
    localStorage.setItem("keepmelogin", false);
    window.location.reload(true);
  } catch (error) {
    return Promise.reject(error);
  }
};
